<template>
  <div class="login login-register">
      <loading :active.sync="isLoading"
              :can-cancel="true">
      </loading>
      <div class="login-box card">
          <div class="card-body">
              <form v-on:submit.prevent class="form-material">

                <h3 class="box-title m-b-20">{{ page_title }}</h3>
                <div class="form-group ">
                    <div class="col-xs-12">
                      <input v-model="username" class="form-control form-control-sm"  required=""  placeholder="Username" type="text" id="username">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-xs-12">
                        <input v-model="password" :type="'password'" autocomplete="off" class="form-control form-control-sm" placeholder="Password" type="text" id="password">
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-12">
                        <!--<div class="checkbox checkbox-info float-left p-t-0">-->
                            <!--<input id="checkbox-signup" type="checkbox" class="filled-in chk-col-light-blue">-->
                            <!--<label for="checkbox-signup"> Remember me </label>-->
                        <!--</div>-->
                      <a @click="goToForget()" href="javascript:void(0)" id="to-recover" class="text-muted float-right"><i class="fa fa-lock m-r-5"></i> Forgot pwd?</a>
                    </div>
                </div>
                <div class="form-group text-center">
                    <div class="col-xs-12 p-b-20 submit-button">
                        <button v-on:click="login()" class="btn btn-block btn-lg btn-info btn-rounded">Log In</button>
                    </div>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Login',
    },
    name: 'Login',
    data () {
      return {
        page_title: 'Login',
        data: {},
        username: null,
        password: null,
        isLoading: false,
      }
    },
    components: {
      Loading,
    },
    methods: {
      goToForget: function() {
        this.$router.push('/send-reset-link/')
      },
      login: function () {
        if (!this.username || this.username.length==0) {
          this.showToastError("Please enter a valid username.")
          return
        }
        if (!this.password || this.password.length==0) {
          this.showToastError("Please enter a valid password.")
          return
        }

        this.isLoading = true

        this.$http
          .post(process.env.API_BASE_URL_CS + 'login/', {
            'username': this.username,
            'password': this.password
          })
          .then(response => {
            console.log('login success')
            console.log(response.data)
            let user = response.data

            if (!user.is_admin && !user.is_agent) {
              user.is_accounting = true
            }
            
            localStorage.setItem('user', JSON.stringify(user))

            this.$store.dispatch('SAVE_USER', user)

            Vue.prototype.$http.defaults.headers.common['Authorization'] = 'JWT ' + user.token

            // @todo populate profile image from login service
            if (user.id_profile_image) {
              console.log(user.id_profile_image.url)
            }

            this.$router.push('/search-rides')

            $('body').removeClass('logged-out');
          })
          .catch(error => {
            console.log(error)
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            this.showToastError("Unable to log in with provided credentials.")
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    mounted: function () {
      $('body').addClass('logged-out');
    },
    created () {
      // document.title = "Wingz Support | Login";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }

  textarea {
    width: 100%;
  }
</style>
<style >

body.logged-out .page-wrapper {
  margin-left: 0px;
}
body.logged-out .sidebartoggler, body.logged-out .topbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue